import { RoomPid, RtmpDestinationV2Entity } from "@common/domain";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IN_USE_DESTINATIONS_SHORT_LIST_MAX_LENGTH } from "@youm-front/destinations/domain";
import {
  RTMP_DESTINATIONS_FEATURE_KEY,
  RtmpDestinationsState,
  destinationsAdapter
} from "../reducer";

const { selectAll } = destinationsAdapter.getSelectors();

const rtmpDestinationsState = createFeatureSelector<RtmpDestinationsState>(
  RTMP_DESTINATIONS_FEATURE_KEY
);

export const destinations = createSelector(
  rtmpDestinationsState,
  (state: RtmpDestinationsState) =>
    selectAll(state).map((_) => new RtmpDestinationV2Entity(_))
);
export const inUseDestinations = createSelector(destinations, (_) =>
  _.filter((_) => _.value.roomId)
);
export const notInUseDestinations = createSelector(destinations, (_) =>
  _.filter((_) => !_.value.roomId)
);
export const inUseDestinationsShortList = (roomId: RoomPid) =>
  createSelector(destinations, (_) => {
    const inUseDestinations = _.filter((_) => _.value.roomId === roomId);
    const shortList = inUseDestinations.slice(
      0,
      IN_USE_DESTINATIONS_SHORT_LIST_MAX_LENGTH
    );
    const truncated = inUseDestinations.length - shortList.length;

    return { shortList, truncated };
  });

export const isLoading = createSelector(
  rtmpDestinationsState,
  (state: RtmpDestinationsState) => state.isLoading
);

export const count = createSelector(
  rtmpDestinationsState,
  (state: RtmpDestinationsState) => state.ids.length
);
